import React from 'react'
import PageHeader from '../components/PageHeader'
import GallerySection from '../components/GallerySection'
import PriceBanner from '../components/PriceBanner'
import ContactForm from '../components/ContactForm'
import { COMPANY_INFO } from '../lib/constants'

export default function Kabeltraek() {
  return (
    <div className="space-y-16">
      <PageHeader
        badge="Specialkompetence"
        title="Lange Kabeltræk & Kabelgravning"
        subtitle="Eget specialudviklet kabelaftrækkersystem på minilæsser. Op til 3 kabler ad gangen, op til 2 km kabel om dagen og arbejde efter kabelplan."
        breadcrumb="Kabeltræk"
      />

      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        {/* Main Content & Scrape Fidelity */}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-start">
          <div className="lg:col-span-8 space-y-8">
            {/* Core Overview & Verbatim Scrape */}
            <div className="bg-white rounded-3xl border border-slate-200 p-8 sm:p-10 shadow-sm space-y-6">
              <div className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-widest text-[#55565C]">
                <span className="w-1.5 h-1.5 rounded-full bg-[#E36C0A]" aria-hidden="true" />
                <span>Teknisk effektivitet på byggepladsen</span>
              </div>
              <h2 className="text-2xl sm:text-3xl font-extrabold text-slate-900 tracking-tight">
                Billigst og mest effektiv på lange kabeltræk
              </h2>

              {/* Exact verbatim scrape text */}
              <div className="prose max-w-none text-slate-700 font-normal leading-relaxed space-y-4">
                <p className="font-normal">
                  Jeg har specialiseret mig i opgaver i højden og billigst på lange kabeltræk.
                </p>
                <p className="font-normal">
                  Ved de store opgaver har jeg udviklet et specielt kabel aftrækker system på en minilæsser. Når jeg trækker kabler på store byggerier trækker jeg op til 3 stk. ad gangen og op til ca. 2 km kabel om dagen. Her kan jeg tilbyde en pakkeløsning på Saxelift, 1,5 km kabelaftrækker og erfaren elektriker i store kabeltræk i de forskellige el områder. Jeg udføre meget gerne kabeltræk med kabelplan. Virkelig en undervurderet ressource ikke at investere i, da man fremtids sikre sin installation for hurtigere fejlfinding og nemmere udbygning/ombygning af installation.
                </p>
                <div className="p-4 bg-slate-50 rounded-2xl border border-slate-200 my-4 text-slate-900 font-normal text-base">
                  <em className="italic">Vidste du at der er ca. halvpris pr. meter kabel når de købes i 500 meters ruller?</em>
                </div>
                <p className="font-normal">
                  Jeg tilbyder også mindre grave opgaver, primær fokus ligger i at grave kabler i jorden på private arealer. Jeg graver og tildækker efter opgavens omfang – kontakt for et uforpligtende tilbud. <em className="italic">Jeg er fuldt ud forsikret om jeg arbejder med din el installation, arbejde i højden nær din bygning eller graver i din have</em>
                </p>
              </div>
            </div>

            {/* Specifikations- og kapacitetsfordele */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
              <div className="bg-gradient-to-br from-[#141628] via-[#1A1D37] to-[#121321] text-white rounded-3xl p-6 sm:p-8 space-y-3 border border-[#2D346E]/60 shadow-md">
                <div className="w-11 h-11 rounded-full bg-[#252A6E] text-[#E36C0A] border border-[#3C449E]/40 flex items-center justify-center text-lg">
                  <i className="fa-solid fa-wave-pulse" aria-hidden="true" />
                </div>
                <div className="text-3xl font-extrabold text-white">
                  3 kabler ad gangen
                </div>
                <h3 className="font-bold text-lg text-white">
                  Kabelaftrækker på minilæsser
                </h3>
                <p className="text-xs sm:text-sm text-[#9FA6D9] leading-relaxed">
                  Jakobs specialudviklede system monteret på minilæsser aflaster mandskab og trækker op til tre kabler parallelt med konstant jævn trækstyrke.
                </p>
              </div>

              <div className="bg-gradient-to-br from-[#141628] via-[#1A1D37] to-[#121321] text-white rounded-3xl p-6 sm:p-8 space-y-3 border border-[#2D346E]/60 shadow-md">
                <div className="w-11 h-11 rounded-full bg-[#252A6E] text-[#E36C0A] border border-[#3C449E]/40 flex items-center justify-center text-lg">
                  <i className="fa-solid fa-gauge-high" aria-hidden="true" />
                </div>
                <div className="text-3xl font-extrabold text-white">
                  Op til 2 km / dag
                </div>
                <h3 className="font-bold text-lg text-white">
                  Enorm dagskapacitet
                </h3>
                <p className="text-xs sm:text-sm text-[#9FA6D9] leading-relaxed">
                  Stor fremdrift på store byggesager, lagerbygninger, haller og erhvervsprojekter. Reducerer byggetiden og de samlede timer væsentligt.
                </p>
              </div>
            </div>

            {/* PAKKELØSNING SEKTION — EXPLICIT PROMPT REQUIREMENT */}
            <div className="bg-white border border-slate-200 rounded-3xl p-8 sm:p-10 shadow-sm space-y-6">
              <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
                <div>
                  <span className="inline-block text-[11px] font-bold uppercase tracking-widest text-[#55565C] bg-slate-100 px-3 py-1 rounded-full mb-2">
                    Komplet enterprise pakkeløsning
                  </span>
                  <h3 className="text-2xl font-extrabold text-slate-900 tracking-tight">
                    Saxelift + 1,5 km kabelaftrækker + Elektriker
                  </h3>
                </div>
                <div className="shrink-0">
                  <a
                    href={`tel:${COMPANY_INFO.phoneRaw}`}
                    className="inline-flex items-center gap-2 rounded-full bg-[#18191D] hover:bg-[#292A30] text-white font-bold text-xs uppercase tracking-wider px-5 py-3 shadow whitespace-nowrap transition-colors"
                  >
                    <span>Få tilbud på pakken</span>
                    <span aria-hidden="true">↗</span>
                  </a>
                </div>
              </div>

              <p className="text-[#55565C] text-sm leading-relaxed">
                Til større byggerier, entreprenører og installationsvirksomheder tilbyder Jakob denne stærke pakke. Den kombinerer egen 8m saxelift, 1,5 km kabelaftrækkersystem på minilæsser og en faglært elektriker med 25 års erfaring i store kabeltræk.
              </p>

              <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 pt-2">
                <div className="bg-slate-50 p-4 rounded-xl border border-slate-200/80">
                  <div className="font-bold text-slate-900 text-sm mb-1 flex items-center gap-2">
                    <span className="w-1.5 h-1.5 rounded-full bg-[#E36C0A]" aria-hidden="true" />
                    <span>Saxelift (8m)</span>
                  </div>
                  <p className="text-xs text-[#55565C]">Mobil til indendørs og udendørs højdearbejde.</p>
                </div>
                <div className="bg-slate-50 p-4 rounded-xl border border-slate-200/80">
                  <div className="font-bold text-slate-900 text-sm mb-1 flex items-center gap-2">
                    <span className="w-1.5 h-1.5 rounded-full bg-[#E36C0A]" aria-hidden="true" />
                    <span>1,5 km aftrækker</span>
                  </div>
                  <p className="text-xs text-[#55565C]">Monteret på minilæsser for høj kapacitet.</p>
                </div>
                <div className="bg-slate-50 p-4 rounded-xl border border-slate-200/80">
                  <div className="font-bold text-slate-900 text-sm mb-1 flex items-center gap-2">
                    <span className="w-1.5 h-1.5 rounded-full bg-[#E36C0A]" aria-hidden="true" />
                    <span>Faglært elektriker</span>
                  </div>
                  <p className="text-xs text-[#55565C]">25 års erfaring med store kabelplaner.</p>
                </div>
              </div>
            </div>

            {/* KABELGRAVNING PÅ PRIVATE AREALER — EXPLICIT REQUIREMENT */}
            <div className="bg-white rounded-3xl border border-slate-200 p-8 sm:p-10 shadow-sm space-y-6">
              <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
                <div>
                  <span className="text-[11px] font-bold uppercase tracking-widest text-[#55565C] bg-slate-100 px-3 py-1 rounded-full inline-block mb-2">
                    Have, indkørsel & jordarealer
                  </span>
                  <h3 className="text-2xl font-extrabold text-slate-900 tracking-tight">
                    Kabelgravning og tildækning på private arealer
                  </h3>
                </div>
                <div className="bg-[#252A6E] text-white font-bold text-xs uppercase tracking-wider px-5 py-3 rounded-2xl shrink-0 text-center shadow-sm border border-[#3C449E]/50">
                  Indhent tilbud
                </div>
              </div>

              <p className="text-slate-700 text-sm sm:text-base leading-relaxed">
                Skal du have trukket strøm til garage, udhus, ladeboks til elbil, havebelysning eller varmepumpe? Jakob udfører selv mindre graveopgaver med fokus på at lægge kabler i jorden på private arealer. Han graver og tildækker med skånsom præcision og pæn retablering. Ring gerne for en uforpligtende snak og et godt tilbud på din opgave.
              </p>

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 text-xs sm:text-sm text-slate-600 pt-2">
                <div className="flex items-center gap-2.5">
                  <i className="fa-solid fa-check text-emerald-600" aria-hidden="true" />
                  <span>Skånsom fremgangsmåde i have og græsplæne</span>
                </div>
                <div className="flex items-center gap-2.5">
                  <i className="fa-solid fa-check text-emerald-600" aria-hidden="true" />
                  <span>Korrekt dybde og advarselsbånd</span>
                </div>
                <div className="flex items-center gap-2.5">
                  <i className="fa-solid fa-check text-emerald-600" aria-hidden="true" />
                  <span>Pæn og ensartet retablering/tildækning</span>
                </div>
                <div className="flex items-center gap-2.5">
                  <i className="fa-solid fa-check text-emerald-600" aria-hidden="true" />
                  <span>Fuldt ud forsikret ved gravearbejde</span>
                </div>
              </div>
            </div>
          </div>

          {/* Sidebar */}
          <div className="lg:col-span-4 space-y-6">
            <div className="bg-gradient-to-br from-[#141628] via-[#1A1D37] to-[#121321] text-white rounded-3xl p-6 sm:p-8 shadow-xl border border-[#2D346E]/60 space-y-6">
              <div>
                <span className="inline-flex items-center gap-2 text-[11px] font-bold uppercase tracking-widest text-[#B5BBE8] mb-2 bg-[#252A6E]/50 border border-[#3C449E]/40 px-3 py-1 rounded-full">
                  <span className="w-1.5 h-1.5 rounded-full bg-[#E36C0A]" aria-hidden="true" />
                  <span>Direkte kontakt</span>
                </span>
                <h3 className="text-2xl font-extrabold tracking-tight text-white mt-1">
                  Tal med Jakob om kabeltræk
                </h3>
                <p className="text-[#9FA6D9] text-xs sm:text-sm mt-2 leading-relaxed">
                  Send en kabelplan eller ring for at drøfte tidsplan, maskinel og kapacitet.
                </p>
              </div>

              <a
                href={`tel:${COMPANY_INFO.phoneRaw}`}
                className="flex items-center justify-center gap-2.5 w-full rounded-full bg-[#E36C0A] hover:bg-[#B95000] text-white font-bold px-6 py-3.5 shadow-md transition-colors text-xs uppercase tracking-wider whitespace-nowrap"
              >
                <i className="fa-solid fa-phone text-xs" aria-hidden="true" />
                <span>Ring: {COMPANY_INFO.phone}</span>
              </a>

              <div className="pt-4 border-t border-[#2D346E]/60 space-y-2 text-xs text-[#9FA6D9]">
                <div className="flex items-center justify-between">
                  <span>Kabeltrækkapacitet:</span>
                  <strong className="text-white font-bold">Op til 2 km / dag</strong>
                </div>
                <div className="flex items-center justify-between">
                  <span>Samtidige kabler:</span>
                  <strong className="text-white font-bold">Op til 3 stk.</strong>
                </div>
                <div className="flex items-center justify-between">
                  <span>Kabelgravning:</span>
                  <strong className="text-white font-bold">Ring for tilbud</strong>
                </div>
                <div className="flex items-center justify-between">
                  <span>Timepris:</span>
                  <strong className="text-white font-bold">485 kr. ex. moms</strong>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Dynamic CMS Gallery for Kabeltræk */}
        <GallerySection
          gallerySlug="kabeltraek"
          title="Galleri: Kabeltræk & Maskinpark"
          subtitle="Billeder af kabelaftrækkersystem på minilæsser, kabeltromler og kabelgravning."
        />

        {/* Price Banner */}
        <PriceBanner showCablePrice={true} />

        {/* Contact Form Section */}
        <div className="my-12">
          <ContactForm />
        </div>
      </div>
    </div>
  )
}
